const rxProductSubmitTabs = document.querySelectorAll(".rx-product-submit-tab-toggle")
  , closeOD = document.querySelectorAll("[data-target=od-popup]")
  , openOD = document.querySelectorAll("[data-value=od-popup]")
  , closePD = document.querySelectorAll("[data-target=pd-popup]")
  , openPD = document.querySelectorAll("[data-value=pd-popup]")
  , closePDUploader = document.querySelectorAll("[data-target=pd-popup-uploader]")
  , openPDUploader = document.querySelectorAll("[data-value=pd-popup-uploader]")
  , pdNumbers = document.querySelectorAll(".rx-product-submit-pd-number")
  , addToCartBtns = document.querySelectorAll('.rx-product-submit-pd-body .add-to-cart-button, div[data-target="submit-later"]')
  , rightSphere = document.querySelector("#right-sphere")
  , rightCylinder = document.querySelector("#right-cylinder")
  , rightAxis = document.querySelector("#right-axis")
  , leftSphere = document.querySelector("#left-sphere")
  , leftCylinder = document.querySelector("#left-cylinder")
  , leftAxis = document.querySelector("#left-axis")
  , additionalInfoCheckbox = document.querySelector("#_rx_additional_data_checkbox")
  , additionalInfoLabel = document.querySelector("#rx-additional-data-label")
  , additionalInfoSection = document.querySelector(".rx-additional-data-body")
  , additionalInfoTextarea = document.querySelector("#_additional_data_text")
  , additionalInfoTextareaCount = document.querySelector(".rx-additional-data-body .numerics span")
  , leftCorrection = document.querySelector("#left-correction")
  , rightCorrection = document.querySelector("#right-correction")
  , manuallyRightPD = document.querySelectorAll("#m-pd-right")
  , manuallyLeftPD = document.getElementById("m-pd-left")
  , rxSelects = document.querySelectorAll(".rx-product-submit-pd .rx-product-submit-od-eye-select-wrapper")
  , rxSubmitSelects = document.querySelectorAll(".rx-product-submit select")
  , confirmCheckbox = document.querySelector(".rx-product-submit-confirm input")
  , rxUploader = document.getElementById("rx-uploader")
  , resetButton = document.querySelectorAll(".rx-product-submit-banner-button")
  , rxLoader = document.getElementById("rx-product-section-loading");

let payload = {};

function getCartDrawerSectionId() {
    return document.querySelector("#shopify-section-cart-drawer")?.dataset.sectionId || "cart-drawer";
}

function replaceCartDrawerContent(sectionHtml) {
    if (!sectionHtml) return;
    const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
    const nextHolder = doc.querySelector("#shopify-section-cart-drawer .section_holder") || doc.querySelector(".section_holder");
    const currentHolder = document.querySelector("#shopify-section-cart-drawer .section_holder");
    if (nextHolder && currentHolder) {
        currentHolder.innerHTML = nextHolder.innerHTML;
        window.updateCartDrawerShippingDisplay?.();
        window.loadCartRecommendations?.();
    }
}

function replaceCartDrawerContentFromSections(sections) {
    const sectionId = getCartDrawerSectionId();
    replaceCartDrawerContent(sections?.[sectionId] || sections?.["cart-drawer"]);
}

const state = {
    hasError: !0,
    rxProducts: [],
    toUpdatedProducts: [],
    loading: !1,
    uploadMessage: null,
    isOrder: {
        enable: !1,
        orderID: "",
        orderNumber: ""
    },
    errors: {
        rightSphere: null,
        rightCylinder: null,
        rightAxis: null,
        rightCorrection: null,
        leftSphere: null,
        leftCylinder: null,
        leftAxis: null,
        leftCorrection: null,
        manuallyRightPD: null,
        manuallyLeftPD: null
    },
    incompatibleFrames: [],
    highIndexQueue: [],
    products: [],
    hasAdditionalData: !1,
    additionalInfoData: "",
    uploaderFileState: {
        files: null,
        imageUrl: ""
    },
    developmentMode: !1
};

// ─── Helper: Prescription Product Check ─────────────────────────────────────
const isEligibleForRx = item => item.product_type === "Prescription" || (item.product_type === "Ophthalmic" && item.variant_options && item.variant_options[0] === "Prescription");

// ─── Page Load: Scroll Lock + Cart Upload Sync ───────────────────────────────
document.querySelector("html").style.overflow = "hidden";

setTimeout(() => {
    (function () {
        fetch("/cart.js").then(res => res.json()).then(cart => {
            let uploadValue = null;
            let prescriptionItems = [];

            cart.items.forEach(item => {
                if (isEligibleForRx(item)) {
                    prescriptionItems.push(item);
                    if (item.properties && item.properties["_upload"] && !uploadValue) {
                        uploadValue = item.properties["_upload"];
                    }
                }
            });

            if (!uploadValue || prescriptionItems.length === 0) {
                rxLoader.style.display = "none";
                document.querySelector("html").style.overflow = "auto";
                return;
            }

            // Find items that are missing the shared upload value
            let itemsToUpdate = prescriptionItems.filter(item =>
                !item.properties ||
                !item.properties["_upload"] ||
                item.properties["_upload"] !== uploadValue
            );

            if (itemsToUpdate.length === 0) {
                rxLoader.style.display = "none";
                document.querySelector("html").style.overflow = "auto";
                state.uploaderFileState.imageUrl = uploadValue;

                const uploadPreview = document.querySelector(".rx-product-submit-upload-preview");
                uploadPreview.classList.add("active");
                uploadPreview.querySelector("span").textContent = uploadValue;
                uploadPreview.querySelector("#edit-uploaded").addEventListener("click", () => {
                    state.uploaderFileState.files = null;
                    state.uploaderFileState.imageUrl = "";
                    state.uploadMessage = null;
                    const uploaderWrapper = document.querySelector(".rx-product-submit-uploader");
                    const uploaderMessage = document.querySelector(".rx-product-submit-upload-message");
                    const uploadPreview = document.querySelector(".rx-product-submit-upload-preview");
                    uploaderWrapper.classList.remove("uploaded");
                    uploaderWrapper.classList.remove("uploading");
                    uploadPreview.classList.remove("active");
                    uploaderMessage.textContent = "";
                    $("#rx_upload_result").hide();
                    $("#rx_upload_result a").attr("href", "");
                    rxUploader.value = null;
                });
                uploadPreview.querySelector("#preview-uploaded").addEventListener("click", () => {
                    uploadValue
                        ? (document.querySelector("#rx-product-section-upload-preview img").setAttribute("src", uploadValue),
                           document.querySelector("#rx-product-section-upload-preview").classList.add("active"))
                        : window.open(uploadValue);
                });
                document.querySelector(".rx-product-section-upload-preview-overlay").addEventListener("click", () => {
                    document.querySelector("#rx-product-section-upload-preview").classList.remove("active");
                });
                $("#rx_upload_result a").attr("href", `${state.uploaderFileState.imageUrl}`);
                $("#rx_upload_result").show();
                return;
            }

            // Get source item properties to sync rx data across all rx items
            let sourceItemProps = {};
            cart.items.forEach(item => {
                if (isEligibleForRx(item) && item.properties && item.properties["_upload"] === uploadValue) {
                    sourceItemProps = item.properties;
                }
            });

            // FIX: Propagate upload URL and rx data to all items using /cart/change.js sequentially
            const updateCartSequential = async () => {
                const rxKeysToSync = ["_upload", "_choice", "_right_sphere", "_right_cylinder", "_right_axis", "_left_sphere", "_left_cylinder", "_left_axis", "_pd", "_pd_right", "_pd_left", "_left_correction", "_right_correction", "_additional_data_text", "_order_id", "_order_number"];
                for (const item of itemsToUpdate) {
                    const newProps = Object.assign({}, item.properties || {});
                    rxKeysToSync.forEach(k => {
                        if (sourceItemProps[k] !== undefined) newProps[k] = sourceItemProps[k];
                    });
                    newProps["_upload"] = uploadValue;

                    await fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id: item.key,
                            quantity: item.quantity,
                            properties: newProps
                        })
                    });
                }
                return true;
            };

            return updateCartSequential();
        }).then(res => {
            if (res) {
                window.location.href = "/checkout";
            }
        }).catch(err => {
            console.error(err);
            window.location.href = "/checkout";
        });
    })();
}, 0);

// ─── Main Init ───────────────────────────────────────────────────────────────
setTimeout(async () => {

    rxProductSubmitTabs.forEach(item => {
        item.addEventListener("click", () => {
            rxProductSubmitTabs.forEach(i => { i.classList.remove("active"); });
            item.classList.add("active");

            if (item.getAttribute("data-target") !== "submit-later") {
                pdNumbers[0].classList.add("active");
                pdNumbers[1].classList.remove("active");
                rxSelects[1].classList.remove("active");
                document.querySelectorAll(".rx-product-submit-pd-numbers-flex").forEach(item2 => {
                    item2.classList.remove("active");
                });
                document.querySelectorAll(".rx-product-submit-tab").forEach(item2 => {
                    item2.classList.remove("active");
                });
                document.getElementById(item.getAttribute("data-target")).classList.add("active");
            }

            if (localStorage.getItem("rx") && localStorage.getItem("rx") !== "null") {
                const properties = JSON.parse(localStorage.getItem("rx"));
                if (item.getAttribute("data-target") === "enter-manually" && properties._choice === "ENTER MANUALLY") {
                    document.getElementById(item.getAttribute("data-target")).querySelector(".rx-product-submit-banner").classList.add("active");
                    for (const property in properties) {
                        if (property !== "_choice") {
                            if (property === "_pd_right" || property === "_pd_left") {
                                document.getElementById("enter-manually").querySelectorAll("#m-" + property.replace("_", "").replaceAll("_", "-")).forEach(el => {
                                    el.value = properties[property];
                                });
                            } else if (property === "_pd") {
                                pdNumbers.forEach(number => { number.classList.remove("active"); });
                                document.querySelector("#m-pd-" + properties[property]).classList.add("active");
                                if (properties[property] === "2") {
                                    document.getElementById("enter-manually").querySelector(".rx-product-submit-pd-numbers-flex").classList.add("active");
                                    const newTitle = document.getElementById("enter-manually").querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select-wrapper")[0].querySelector(".rx-product-submit-od-eye-select-name").innerHTML.replace("Total Pupillary Distance", "OS Left");
                                    document.getElementById("enter-manually").querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select-wrapper")[0].querySelector(".rx-product-submit-od-eye-select-name").innerHTML = newTitle;
                                    document.getElementById("enter-manually").querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select-wrapper").forEach(element => {
                                        element.classList.add("active");
                                    });
                                    document.querySelector(".rx-product-submit-od-eye-input").style.display = "none";
                                    document.querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select")[0].style.display = "block";
                                }
                            } else if (property === "_additional_data_text") {
                                desanitize(properties[property]).length
                                    ? (state.hasAdditionalData = !0,
                                       additionalInfoCheckbox.checked = !0,
                                       additionalInfoTextarea.value = desanitize(properties[property]),
                                       additionalInfoTextareaCount.innerHTML = additionalInfoTextarea.value.length,
                                       state.additionalInfoData = additionalInfoTextarea.value)
                                    : (state.hasAdditionalData = !1,
                                       additionalInfoCheckbox.checked = !1,
                                       additionalInfoTextarea.value = "",
                                       additionalInfoTextareaCount.innerHTML = 0,
                                       state.additionalInfoData = "");
                            } else if (document.getElementById("enter-manually").querySelector("#" + property.replace("_", "").replaceAll("_", "-"))) {
                                document.getElementById("enter-manually").querySelector("#" + property.replace("_", "").replaceAll("_", "-")).value = properties[property];
                                if (property === "_upload" && (
                                    document.querySelector(".rx-product-submit-uploader").classList.add("uploaded"),
                                    state.uploadMessage = properties[property],
                                    state.uploadMessage.length > 0)) {
                                    const uploadPreview = document.querySelector(".rx-product-submit-upload-preview");
                                    uploadPreview.querySelector("span").textContent = state.uploadMessage;
                                    uploadPreview.classList.add("active");
                                    uploadPreview.querySelector("#edit-uploaded").addEventListener("click", () => { rxUploaderWipeStatus(); });
                                    uploadPreview.querySelector("#preview-uploaded").addEventListener("click", () => {
                                        state.uploadMessage.includes("jpeg") || state.uploadMessage.includes("png") || state.uploadMessage.includes("jpg") || state.uploadMessage.includes("webp") || state.uploadMessage.includes("gif") || state.uploadMessage.includes("avif")
                                            ? (document.querySelector("#rx-product-section-upload-preview img").setAttribute("src", state.uploadMessage),
                                               document.querySelector("#rx-product-section-upload-preview").classList.add("active"))
                                            : window.open(state.uploadMessage);
                                    });
                                    document.querySelector(".rx-product-section-upload-preview-overlay").addEventListener("click", () => {
                                        document.querySelector("#rx-product-section-upload-preview").classList.remove("active");
                                    });
                                    $("#rx_upload_result a").attr("href", state.uploadMessage);
                                    $("#rx_upload_result").show();
                                }
                            }
                        }
                    }
                    properties._pd === "1"
                        ? document.querySelectorAll("#m-pd-right")[0].value = properties._pd_right * 2
                        : document.querySelectorAll("#m-pd-right")[1].value = properties._pd_right;
                }
            }
            document.querySelectorAll(".rx-product-submit-error").forEach(error => {
                error.classList.remove("active");
            });
        });
    });

    rxProductSubmitTabs[0].click();

    closeOD.forEach(item => {
        item.addEventListener("click", () => {
            document.getElementById(item.getAttribute("data-target")).classList.remove("active");
        });
    });
    openOD.forEach(item => {
        item.addEventListener("click", () => {
            document.getElementById(item.getAttribute("data-value")).classList.add("active");
        });
    });
    closePD.forEach(item => {
        item.addEventListener("click", () => {
            document.getElementById(item.getAttribute("data-target")).classList.remove("active");
        });
    });
    openPD.forEach(item => {
        item.addEventListener("click", () => {
            document.getElementById(item.getAttribute("data-value")).classList.add("active");
        });
    });
    closePDUploader.forEach(item => {
        item.addEventListener("click", () => {
            document.getElementById(item.getAttribute("data-target")).classList.remove("active");
        });
    });
    openPDUploader.forEach(item => {
        item.addEventListener("click", () => {
            document.getElementById(item.getAttribute("data-value")).classList.add("active");
        });
    });

    pdNumbers.forEach(item => {
        item.addEventListener("click", () => {
            pdNumbers.forEach(number => { number.classList.remove("active"); });
            item.classList.add("active");
            pdNumbers[1].classList.contains("active")
                ? (rxSelects[1].classList.add("active"),
                   document.querySelectorAll(".rx-product-submit-pd-numbers-flex")[0].classList.add("active"),
                   document.querySelector(".rx-product-submit-od-eye-input").style.display = "none",
                   document.querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select").forEach(el => { el.style.display = "block"; }),
                   document.getElementById("enter-manually").querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select-wrapper")[0].querySelector(".rx-product-submit-od-eye-select-name").innerHTML = 'OS Left <span class="rx-product-submit-od-eye-select-start">*</span>')
                : (rxSelects[1].classList.remove("active"),
                   document.querySelectorAll(".rx-product-submit-pd-numbers-flex")[0].classList.remove("active"),
                   document.querySelector(".rx-product-submit-od-eye-input").style.display = "block",
                   document.querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select").forEach(el => { el.style.display = "none"; }),
                   document.getElementById("enter-manually").querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select-wrapper")[0].querySelector(".rx-product-submit-od-eye-select-name").innerHTML = 'Total Pupillary Distance <span class="rx-product-submit-od-eye-select-start">*</span>');
        });
    });

    rxSubmitSelects.forEach(item => {
        item.addEventListener("change", () => {
            item.value !== "" && item.closest(".rx-product-submit-od-eye-select-wrapper").querySelector(".rx-product-submit-error").classList.remove("active");
        });
    });

    confirmCheckbox.addEventListener("change", () => {
        confirmCheckbox.checked && document.getElementById("confirm-error").classList.remove("active");
    });

    // ─── Add to Cart Button Click ────────────────────────────────────────────
    addToCartBtns.forEach(addToCartBtn => {
        addToCartBtn.addEventListener("click", async () => {
            addToCartBtns[1].classList.add("is-loading");
            addToCartBtns[1].textContent = "";

            const has_progressive = document.querySelector("#rx-product-submit").getAttribute("has-progressive");

            setTimeout(() => {
                const targetTab = document.querySelector(".rx-product-submit-tab-toggle.active").getAttribute("data-target");
                const PDvalue = document.querySelector(".rx-product-submit-pd-number.active").getAttribute("data-value");

                if (targetTab === "submit-later") {
                    state.hasError = !1;
                    payload = { properties: { _choice: "SUBMIT LATER" } };
                    addToCartBtns[1].classList.remove("is-loading");
                    addToCartBtns[1].textContent = "Continue";
                    addVariantToCart();
                }

                if (targetTab === "enter-manually") {
                    rightSphere.value === "" ? (document.getElementById("right-sphere-error").classList.add("active"), state.errors.rightSphere = "<b>Right sphere</b> value(OD) is required") : state.errors.rightSphere = null;
                    rightCylinder.value === "" ? (document.getElementById("right-cylinder-error").classList.add("active"), state.errors.rightCylinder = "<b>Right cylinder</b> value(OD) is required") : state.errors.rightCylinder = null;
                    rightAxis.value === "" ? (document.getElementById("right-axis-error").classList.add("active"), state.errors.rightAxis = "<b>Right axis</b> value(OD) is required") : state.errors.rightAxis = null;
                    leftSphere.value === "" ? (document.getElementById("left-sphere-error").classList.add("active"), state.errors.leftSphere = "<b>Left sphere</b> value(OS) is required") : state.errors.leftSphere = null;
                    leftCylinder.value === "" ? (document.getElementById("left-cylinder-error").classList.add("active"), state.errors.leftCylinder = "<b>Left cylinder</b> value(OS) is required") : state.errors.leftCylinder = null;
                    leftAxis.value === "" ? (document.getElementById("left-axis-error").classList.add("active"), state.errors.leftAxis = "<b>Left axis</b> value(OS) is required") : state.errors.leftAxis = null;

                    payload = {
                        properties: {
                            _right_sphere: rightSphere.value,
                            _right_cylinder: rightCylinder.value,
                            _right_axis: rightAxis.value,
                            _left_sphere: leftSphere.value,
                            _left_cylinder: leftCylinder.value,
                            _left_axis: leftAxis.value,
                            _pd: PDvalue,
                            _choice: "ENTER MANUALLY",
                            _upload: state.uploadMessage || null
                        }
                    };

                    if (has_progressive == "true") {
                        rightCorrection.value === "" ? (document.getElementById("right-correction-error").classList.add("active"), state.errors.rightCorrection = "<b>Right add</b> value(OD) is required") : state.errors.rightCorrection = null;
                        leftCorrection.value === "" ? (document.getElementById("left-correction-error").classList.add("active"), state.errors.leftCorrection = "<b>Left add</b> value(OS) is required") : state.errors.leftCorrection = null;
                        payload.properties._left_correction = leftCorrection.value;
                        payload.properties._right_correction = rightCorrection.value;
                    }

                    if (!state.uploadMessage) delete payload.properties._upload;

                    if (state.isOrder.enable) {
                        payload.properties._order_id = state.isOrder.orderID;
                        payload.properties._order_number = state.isOrder.orderNumber;
                    }

                    if (state.hasAdditionalData) {
                        const sanitizedData = sanitize(state.additionalInfoData.trim());
                        sanitizedData.length && (payload.properties._additional_data_text = sanitizedData);
                    } else {
                        payload.properties._additional_data_text = "";
                    }

                    if (rightSphere.value === "" || rightCylinder.value === "" || rightAxis.value === "" ||
                        leftSphere.value === "" || leftCylinder.value === "" || leftAxis.value === "" ||
                        (has_progressive == "true" && (leftCorrection.value === "" || rightCorrection.value === ""))) {
                        state.hasError = !0;
                    } else {
                        state.hasError = !1;
                    }

                    // PD Validation
                    if (PDvalue === "1") {
                        state.errors.rightPD = null;
                        state.errors.leftPD = null;
                        if (manuallyRightPD[0].value == "" || manuallyRightPD[0].value < 30 || manuallyRightPD[0].value > 80 ||
                            rightSphere.value === "" || rightCylinder.value === "" || rightAxis.value === "" ||
                            leftSphere.value === "" || leftCylinder.value === "" || leftAxis.value === "" ||
                            (has_progressive == "true" && (leftCorrection.value === "" || rightCorrection.value === ""))) {
                            state.hasError = !0;
                        } else {
                            state.hasError = !1;
                        }
                        if (manuallyRightPD[0].value == "") {
                            document.getElementById("m-only-pd-error").classList.add("active");
                            state.errors.onePD = "<b>PD</b> value is required";
                            document.getElementById("m-only-pd-error").innerHTML = "This field is required";
                        } else if (parseFloat(manuallyRightPD[0].value) < 30 || parseFloat(manuallyRightPD[0].value) > 80) {
                            document.getElementById("m-only-pd-error").classList.add("active");
                            state.errors.onePD = "<b>PD</b> is outside the allowed range";
                            document.getElementById("m-only-pd-error").innerHTML = "Your <b>PD</b> is outside the allowed range";
                        } else {
                            document.getElementById("m-only-pd-error").classList.remove("active");
                            state.errors.onePD = null;
                        }
                        payload.properties._pd_right = manuallyRightPD[0].value / 2;
                        payload.properties._pd_left = manuallyRightPD[0].value / 2;
                    } else {
                        state.errors.onePD = null;
                        const pdSum = parseFloat(manuallyLeftPD.value) + parseFloat(manuallyRightPD[1].value);
                        if (manuallyRightPD[1].value === "") {
                            document.getElementById("m-right-pd-error").classList.add("active");
                            state.errors.rightPD = "<b>Right PD</b> value(OD) is required";
                            document.getElementById("m-right-pd-error").innerHTML = "This field is required";
                        } else if (pdSum < 30 || pdSum > 80) {
                            document.getElementById("m-right-pd-error").classList.add("active");
                            state.errors.rightPD = "<b>PD</b> is outside the allowed range";
                            document.getElementById("m-right-pd-error").innerHTML = "Your <b>PD</b> is outside the allowed range";
                        } else {
                            document.getElementById("m-right-pd-error").classList.remove("active");
                            state.errors.rightPD = null;
                        }
                        if (manuallyLeftPD.value === "") {
                            document.getElementById("m-left-pd-error").classList.add("active");
                            state.errors.leftPD = "<b>Left PD</b> value(OS) is required";
                            document.getElementById("m-left-pd-error").innerHTML = "This field is required";
                        } else if (pdSum < 30 || pdSum > 80) {
                            document.getElementById("m-left-pd-error").classList.add("active");
                            state.errors.leftPD = "<b>PD</b> is outside the allowed range";
                            document.getElementById("m-left-pd-error").innerHTML = "Your <b>PD</b> is outside the allowed range";
                        } else {
                            document.getElementById("m-left-pd-error").classList.remove("active");
                            state.errors.leftPD = null;
                        }
                        if (manuallyRightPD[1].value === "" || manuallyLeftPD.value === "" || pdSum < 30 || pdSum > 80 ||
                            rightSphere.value === "" || rightCylinder.value === "" || rightAxis.value === "" ||
                            leftSphere.value === "" || leftCylinder.value === "" || leftAxis.value === "" ||
                            (has_progressive == "true" && (leftCorrection.value === "" || rightCorrection.value === ""))) {
                            state.hasError = !0;
                        } else {
                            state.hasError = !1;
                        }
                        payload.properties._pd_right = manuallyRightPD[1].value;
                        payload.properties._pd_left = manuallyLeftPD.value;
                    }

                    // Axis/Cylinder Cross Validation
                    if (+rightCylinder.value != 0 && +rightAxis.value == 0) { state.hasError = !0; state.errors.rightAxis = "<b>Right Axis</b> should not be 0 when&nbsp;<b>Right Cylinder</b> has a value"; }
                    if (+rightAxis.value != 0 && +rightCylinder.value == 0) { state.hasError = !0; state.errors.rightAxis = "<b>Right Cylinder</b> should not be 0 when&nbsp;<b>Right Axis</b> has a value"; }
                    if (+leftCylinder.value != 0 && +leftAxis.value == 0) { state.hasError = !0; state.errors.leftAxis = "<b>Left Axis</b> should not be 0 when&nbsp;<b>Left Cylinder</b> has a value"; }
                    if (+leftAxis.value != 0 && +leftCylinder.value == 0) { state.hasError = !0; state.errors.leftAxis = "<b>Left Cylinder</b> should not be 0 when&nbsp;<b>Left Axis</b> has a value"; }

                    if (state.hasError) {
                        addToCartBtns[1].classList.remove("is-loading");
                        addToCartBtns[1].textContent = "Continue";
                        openErrorsToast("Validation Failed");
                    } else if (state.isOrder.enable) {
                        addToCartBtns[1].classList.remove("confirm-checkout");
                        addToCartBtns[1].classList.remove("is-loading");
                        addToCartBtns[1].textContent = "Continue";
                        document.querySelector(".rx-form-compatibility .rx-form-frames-list").innerHTML = "";
                        document.querySelector(".rx-form-compatibility").classList.remove("active");
                        openConfirmModal();
                    } else {
                        checkCompatibility();
                    }
                }
            }, 1);
        });
    });

    // ─── Uploader Status Helpers ─────────────────────────────────────────────
    const rxUploaderWipeStatus = () => {
        state.uploaderFileState.files = null;
        state.uploaderFileState.imageUrl = "";
        state.uploadMessage = null;
        const uploaderWrapper = document.querySelector(".rx-product-submit-uploader");
        const uploaderMessage = document.querySelector(".rx-product-submit-upload-message");
        const uploadPreview = document.querySelector(".rx-product-submit-upload-preview");
        uploaderWrapper.classList.remove("uploaded");
        uploaderWrapper.classList.remove("uploading");
        uploadPreview.classList.remove("active");
        uploaderMessage.textContent = "";
        $("#rx_upload_result").hide();
        $("#rx_upload_result a").attr("href", "");
        rxUploader.value = null;
    };

    const rxUploaderRefreshStatus = () => {
        if (!state.uploaderFileState.files || !state.uploaderFileState.files.length) return;
        const uploadPreview = document.querySelector(".rx-product-submit-upload-preview");
        const uploaderWrapper = document.querySelector(".rx-product-submit-uploader");
        uploaderWrapper.classList.remove("uploading");
        uploaderWrapper.classList.add("uploaded");
        document.querySelector("#preview-uploaded").style.display = "none";
        state.uploadMessage = null;
        uploadPreview.classList.add("active");
        uploadPreview.querySelector("span").textContent = state.uploaderFileState.files[0].name;
        uploadPreview.querySelector("#edit-uploaded").addEventListener("click", () => { rxUploaderWipeStatus(); });
        uploadPreview.querySelector("#preview-uploaded").addEventListener("click", () => {
            state.uploaderFileState.files[0].type.includes("image")
                ? (document.querySelector("#rx-product-section-upload-preview img").setAttribute("src", state.uploadMessage),
                   document.querySelector("#rx-product-section-upload-preview").classList.add("active"))
                : window.open(state.uploadMessage);
        });
        document.querySelector(".rx-product-section-upload-preview-overlay").addEventListener("click", () => {
            document.querySelector("#rx-product-section-upload-preview").classList.remove("active");
        });
        $("#rx_upload_result a").attr("href", `https://cdn.shopify.com/s/files/1/0965/2564/8191/uploads/${state.uploaderFileState.imageUrl}`);
        $("#rx_upload_result").show();
    };

    rxUploader.addEventListener("change", () => {
        const uploaderWrapper = document.querySelector(".rx-product-submit-uploader");
        const uploaderMessage = document.querySelector(".rx-product-submit-upload-message");
        uploaderWrapper.classList.add("uploading");
        uploaderWrapper.classList.remove("uploaded");
        addToCartBtns[1].classList.add("disabled");

        const permittedExtensions = ["image/jpeg", "image/png", "image/jpg", "image/webp", "image/gif", "image/avif", "application/pdf"];
        const uploadPreview = document.querySelector(".rx-product-submit-upload-preview");
        let isPermittedToUpload = !0;

        if (rxUploader.files.length > 0) {
            if (!permittedExtensions.includes(rxUploader.files[0].type)) {
                uploaderWrapper.classList.add("uploaded");
                uploaderMessage.style.color = "red";
                uploaderMessage.textContent = "The chosen file must be image or PDF, you selected file type is " + rxUploader.files[0].type;
                isPermittedToUpload = !1;
                uploadPreview.classList.remove("active");
                state.uploadMessage = null;
            }
            if (rxUploader.files[0].size > 7340032) {
                uploaderWrapper.classList.add("uploaded");
                uploaderMessage.style.color = "red";
                uploaderMessage.textContent = "The chosen file must be lower or equal than 7MB, your selected file is equal to " + parseFloat(rxUploader.files[0].size / 1048576).toFixed(2) + " MB";
                isPermittedToUpload = !1;
                uploadPreview.classList.remove("active");
                state.uploadMessage = null;
            }
            if (!isPermittedToUpload) {
                uploaderWrapper.classList.remove("uploading");
                return;
            }
            uploaderWrapper.classList.remove("uploaded");
            uploaderMessage.textContent = "";
            state.uploaderFileState.files = rxUploader.files;
            state.uploaderFileState.imageUrl = rxUploader.files;
            uploaderWrapper.classList.remove("uploading");
            addToCartBtns[1].classList.remove("disabled");
            rxUploaderRefreshStatus();
        } else {
            uploaderWrapper.classList.remove("uploading");
            addToCartBtns[1].classList.remove("disabled");
            rxUploaderRefreshStatus();
        }
    });

    additionalInfoLabel.addEventListener("click", () => {
        const newState = !state.hasAdditionalData;
        additionalInfoCheckbox.checked = newState;
        state.hasAdditionalData = newState;
        newState ? showAdditionalInfoSection() : hideAdditionalInfoSection();
    });

    resetButton.forEach(reset => {
        reset.addEventListener("click", () => { resetForm(); });
    });

    state.hasAdditionalData ? showAdditionalInfoSection() : hideAdditionalInfoSection();

    additionalInfoTextarea.addEventListener("input", () => {
        state.additionalInfoData = additionalInfoTextarea.value;
        additionalInfoTextareaCount.innerHTML = additionalInfoTextarea.value.length;
    });

}, 1e3);

// ─── Utility Functions ───────────────────────────────────────────────────────
const sanitize = string => {
    function stripHtml(html) {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || "").slice(0, 200);
    }
    return stripHtml(string);
};

const desanitize = string => string;

const addVariantToCart = () => {
    state.hasError || (state.isOrder.enable ? sendOrder() : getRxProducts());
};

// ─── checkCompatibility: Build toUpdatedProducts from ALL rx items ────────────
const checkCompatibility = () => {
    fetch("/cart.js").then(response => response.json()).then(data => {
        state.rxProducts = data.items.filter(item => isEligibleForRx(item));

        if (state.rxProducts.length === 0) {
            window.location = "/checkout";
            return;
        }

        state.incompatibleFrames = [];

        // FIX: Build toUpdatedProducts for ALL rx items with payload merged in
        state.toUpdatedProducts = state.rxProducts.map(product => {
            // Start from existing properties, then merge new prescription payload on top
            const mergedProps = Object.assign({}, product.properties || {}, payload.properties);

            // Preserve frame-specific keys from the original item (not overwritten by prescription payload)
            const frameKeys = ["_upload", "_frame_color", "_prescription_type", "_lens_color", "_lens_upgrades", "_SKU", "_range", "_choice",
                               "_collection", "_right_sphere", "_right_cylinder", "_right_axis",  "_left_sphere", "_left_cylinder", "_left_axis", "_pd", "_pd_right", "_pd_left", "_highindex_upgrade"];
            frameKeys.forEach(k => {
                if (product.properties && product.properties[k] !== undefined && !(k in payload.properties)) {
                    mergedProps[k] = product.properties[k];
                }
            });

            return {
                key: product.key,
                id: product.variant_id,
                qty: product.quantity,
                properties: mergedProps
            };
        });

        // Check incompatibility for each rx product
        state.rxProducts.forEach(product => {
            if (!product?.properties?._lens_upgrades?.toLowerCase().includes("high index") &&
                product?.properties?._range &&
                !addToCartBtns[1].classList.contains("confirm-checkout")) {
                const min = parseFloat(product.properties._range.split(":")[0]);
                const max = parseFloat(product.properties._range.split(":")[1]);
                let leftTotalRange = parseFloat(leftCylinder.value) + parseFloat(leftSphere.value);
                let rightTotalRange = parseFloat(rightCylinder.value) + parseFloat(rightSphere.value);
                if (leftTotalRange < min || leftTotalRange > max || rightTotalRange < min || rightTotalRange > max) {
                    state.incompatibleFrames.push(product);
                }
            }
        });

        addToCartBtns[1].classList.remove("is-loading");
        addToCartBtns[1].textContent = "Continue";

        let listFrames = "";
        const rxCompatibility = document.querySelector(".rx-form-compatibility");

        if (state.incompatibleFrames.length > 0) {
            state.incompatibleFrames.forEach((item, i) => {
                if (!item.title.includes("High Index")) {
                    listFrames += `
                    <div class="rx-form-compatibility-frame" data-id="${item.id}" data-handle="${item.handle}" index="${i}">
                        <img src="${item.image}" style="max-width:150px;border-radius:8px;" alt=""/>
                        <span class="rx-form-compatibility-frame-list-title">
                            <h4 class="rx-form-compatibility-frame-list-name">${item.product_title}</h4>
                            <p class="rx-form-compatibility-frame-list-variantname">${item.variant_title}</p>
                        </span>
                        <div class="rx-form-compatibility-frame-actions"><span>Add High Index</span></div>
                    </div>`;
                }
            });
            rxCompatibility.querySelector(".rx-form-frames-list").innerHTML = listFrames;
            rxCompatibility.classList.contains("active")
                ? (rxCompatibility.classList.add("high-index"), setTimeout(() => { rxCompatibility.classList.remove("high-index"); }, 600))
                : rxCompatibility.classList.add("active");
            addHighIndex();
        } else {
            addToCartBtns[1].classList.remove("confirm-checkout");
            rxCompatibility.querySelector(".rx-form-frames-list").innerHTML = listFrames;
            rxCompatibility.classList.remove("active");
            openConfirmModal();
        }
    }).catch(e => { console.log(e); });
};

const getRxProducts = () => {
    addToCartBtns[1].classList.remove("confirm-checkout");
    const rxCompatibility = document.querySelector(".rx-form-compatibility");
    rxCompatibility.querySelector(".rx-form-frames-list").innerHTML = "";
    rxCompatibility.classList.remove("active");
    updateRxProduct();
};

// ─── KEY FIX: updateRxProduct - Update ALL rx items in-place ─────────────────
// Uses /cart/change.js instead of remove+re-add so no items are ever lost.
// For file upload: updates all items first, then submits hidden form for first
// item only (to get Shopify file storage). The page-load sync propagates the
// resulting _upload URL to remaining items on the next load.
const updateRxProduct = () => {
    addToCartBtns[1].classList.add("is-loading");
    addToCartBtns[1].textContent = "";

    const targetTab = document.querySelector(".rx-product-submit-tab-toggle.active").getAttribute("data-target");
    const hasFileSelected = state.uploaderFileState.files && state.uploaderFileState.files.length > 0;

    fetch("/cart.js")
        .then(res => res.json())
        .then(async cart => {
            const rxItems = cart.items.filter(item => isEligibleForRx(item));

            if (rxItems.length === 0) {
                window.location.href = "/checkout";
                return;
            }

            // Helper: merge existing item props with new payload, preserving frame-specific keys
            const buildProps = (item) => {
                const merged = Object.assign({}, item.properties || {}, payload.properties);
                // Always restore frame-specific keys from original (they must not be blanked by payload)
                const frameKeys = ["_upload", "_frame_color", "_prescription_type", "_lens_color", "_lens_upgrades", "_SKU", "_range", "_choice",
                               "_collection", "_right_sphere", "_right_cylinder", "_right_axis",  "_left_sphere", "_left_cylinder", "_left_axis", "_pd", "_pd_right", "_pd_left", "_highindex_upgrade"];
                frameKeys.forEach(k => {
                    if (item.properties && item.properties[k] !== undefined && !(k in payload.properties)) {
                        merged[k] = item.properties[k];
                    }
                });
                return merged;
            };

            // Save rx data to localStorage
            const rxToSave = Object.assign({}, payload.properties);
            ["_prescription_type","_frame_color","_img","_lens_color","_lens_upgrades","_SKU","_barcode"].forEach(k => delete rxToSave[k]);
            localStorage.setItem("rx", JSON.stringify(rxToSave));

            if (targetTab === "submit-later") {
                // Update all rx items with SUBMIT LATER choice sequentially
                for (const item of rxItems) {
                    const props = buildProps(item);
                    props._choice = "SUBMIT LATER";
                    await fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
                    });
                }
                window.location.href = "/checkout";
                return;
            }

            // Enter Manually: no new file → update all items in-place sequentially then go checkout
            if (!hasFileSelected) {
                for (const item of rxItems) {
                    await fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: buildProps(item) })
                    });
                }
                addToCartBtns[1].classList.remove("is-loading");
                addToCartBtns[1].textContent = "Continue";
                window.location.href = "/checkout";
                return;
            }

            // File upload path:
            // Step 1 - Update all rx items with merged props sequentially (without _upload yet)
            for (const item of rxItems) {
                const props = buildProps(item);
                delete props._upload; // will be set by file upload for first item; propagated by page-load sync for rest
                await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
                });
            }

            // Step 2 - Refetch to get fresh keys
            const freshCart = await fetch("/cart.js").then(r => r.json());
            const firstRxItem = freshCart.items.find(item => isEligibleForRx(item));

            if (!firstRxItem) {
                window.location.href = "/checkout";
                return;
            }

            // Step 3 - Submit hidden form with file for first RX item only
            // Shopify stores the file and sets _upload on that item.
            // Page-load upload sync (top of script) propagates _upload to all other rx items.
            const form = document.getElementById("rxHiddenForm");
            document.getElementById("rxVariantId").value = firstRxItem.variant_id;
            document.getElementById("rxQty").value = firstRxItem.quantity;

            const returnToInput = form.querySelector('input[name="return_to"]');
            if (returnToInput) returnToInput.value = "/checkout";

            // Clear any previously added property inputs, then re-add fresh ones
            form.querySelectorAll('input[name^="properties["]').forEach(el => el.remove());
            const formProps = buildProps(firstRxItem);
            Object.keys(formProps).forEach(key => {
                if (key === "_upload") return; // file input handles this
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = "properties[" + key + "]";
                input.value = formProps[key] !== null && formProps[key] !== undefined ? formProps[key] : "";
                form.appendChild(input);
            });

            document.getElementById("rxHiddenUploader").files = state.uploaderFileState.files;
            addToCartBtns[1].classList.remove("is-loading");
            addToCartBtns[1].textContent = "Continue";
            form.submit();
        })
        .catch(error => {
            console.error("Error updating cart:", error);
            addToCartBtns[1].classList.remove("is-loading");
            addToCartBtns[1].textContent = "Continue";
            window.location.href = "/checkout";
        });
};

const createRequest = (path, method = "GET", body = null) =>
    fetch(path, {
        method,
        body,
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
        }
    }).then(response => response.json());

const resetForm = () => {
    const rxData = localStorage.getItem("rx");
    if (rxData) {
        try {
            const rxObj = JSON.parse(rxData);
            if ("_upload" in rxObj) {
                delete rxObj._upload;
                localStorage.setItem("rx", JSON.stringify(rxObj));
            }
        } catch (e) {
            console.error("error when deleting rx data", e);
        }
    }
    rxSelects.forEach(element => { element.value = ""; });
    rxSubmitSelects.forEach(element => { element.value = ""; });
    pdNumbers[0].classList.add("active");
    pdNumbers[1].classList.remove("active");
    document.querySelectorAll(".rx-product-submit-banner").forEach(banner => { banner.classList.remove("active"); });
    state.uploadMessage = null;
    document.querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select-wrapper")[1].classList.remove("active");
    document.querySelector(".rx-product-submit-od-eye-input").style.display = "block";
    document.querySelector(".rx-product-submit-od-eye-input").value = "";
    document.querySelectorAll(".rx-product-submit-pd-numbers-flex .rx-product-submit-od-eye-select").forEach(el => { el.style.display = "none"; });
    document.querySelector(".rx-product-submit-uploader").classList.remove("uploaded");
    document.querySelector(".rx-product-submit-upload-preview").classList.remove("active");
    additionalInfoCheckbox.checked = !1;
    additionalInfoTextarea.value = "";
    additionalInfoTextareaCount.innerHTML = 0;
    additionalInfoSection.classList.add("no-display");
    state.additionalInfoData = "";
    state.hasAdditionalData = !1;
};

const showAdditionalInfoSection = () => { additionalInfoSection.classList.remove("no-display"); };
const hideAdditionalInfoSection = () => { additionalInfoSection.classList.add("no-display"); };

const show_thank_you_message = () => {
    const Banner = document.querySelector(".rx-product-submit-tab .rx-product-submit-order-banner");
    Banner.classList.add("active");
    Banner.classList.remove("has-error");
    Banner.innerHTML = "Thank you for submitting the Prescription Details.";
    document.querySelector(".rx-product-submit-tab .rx-product-submit-to-hide").style.display = "none";
    document.querySelector(".rx-product-submit-header p").style.display = "none";
    document.querySelector(".rx-product-submit-banner").style.display = "none";
    document.querySelector(".rx-product-submit-tabs-header").style.display = "none";
    document.querySelector(".rx-product-submit-tab").style.padding = "0";
    document.querySelector("#enter-manually").classList.add("active");
    Banner.classList.add("active");
    document.querySelector("#rx-product-section-loading").style.display = "none";
};

const sendOrder = () => {
    addToCartBtns[1].classList.add("is-loading");
    addToCartBtns[1].textContent = "";
    const formdata = new FormData;
    console.log(formdata);
};

const addHighIndex = async () => {
    let upgradeBtns = document.querySelectorAll(".rx-form-compatibility-frame-actions");
    if (upgradeBtns.length) {
        for (const btn of upgradeBtns) {
            let parentEl = btn.closest(".rx-form-compatibility-frame");
            let handle = parentEl.getAttribute("data-handle");
            let index = parentEl.getAttribute("index");
            if (!state.products[handle]) {
                state.products[handle] = await fetch("/products/" + handle + ".json").then(response => response.json());
            }
            const data = state.products[handle];
            let currentVariant = state.incompatibleFrames[index];
            let possibleUpgrades = data.product.variants.filter(i =>
                i.title.includes("High Index") &&
                currentVariant.variant_options.includes(i.option1) &&
                currentVariant.variant_options.includes(i.option2)
            );
            let filterPossibleUpgrades = [];
            possibleUpgrades.forEach((v) => {
                let isPassed = !1;
                if (currentVariant.variant_options[2].split(" + ").length > 1) {
                    v.option3.split(" + ").forEach(option => {
                        if (option != "High Index" && currentVariant.variant_options[2].includes(option) &&
                            currentVariant.variant_options[0].includes(v.option1) &&
                            currentVariant.variant_options[1].includes(v.option2) &&
                            parseFloat(v.price) > 0) { isPassed = !0; }
                    });
                } else if (currentVariant.variant_options[2] == "Standard" || currentVariant.variant_options[2] == "Impact Resistant") {
                    if (v.option3.split(" + ").length === 1) { isPassed = !0; }
                } else {
                    v.option3.split(" + ").forEach(option => {
                        if (option != "High Index" && currentVariant.variant_options[2].includes(option) &&
                            currentVariant.variant_options[0].includes(v.option1) &&
                            currentVariant.variant_options[1].includes(v.option2) &&
                            parseFloat(v.price) > 0) { isPassed = !0; }
                    });
                }
                if (isPassed) { filterPossibleUpgrades.push(v); }
            });
            state.highIndexQueue[index] = null;
            filterPossibleUpgrades.forEach(v => {
                let isUpgradeVariant = !0;
                currentVariant.variant_options[2].replace("Standard", "High Index").replace("Impact Resistant", "High Index").split(" + ").forEach(option => {
                    if (!v.title.includes(option)) { isUpgradeVariant = !1; }
                });
                if (isUpgradeVariant) { state.highIndexQueue[index] = v; }
            });
            if (!state.highIndexQueue[index]) { state.highIndexQueue[index] = filterPossibleUpgrades[0]; }
            let premiumPrice = parseFloat(state.highIndexQueue[index].price) - currentVariant.original_price / 100;
            if (premiumPrice) { btn.querySelector("span").innerHTML += `<br>+$${premiumPrice}`; }
            btn.addEventListener("click", async () => {
                let index2 = btn.closest(".rx-form-compatibility-frame").getAttribute("index");
                if (state.highIndexQueue[index2]) {
                    let upgradedVariant = state.highIndexQueue[index2];
                    const updates = {};
                    updates[currentVariant.id] = "0";
                    await fetch("/cart/update.js", {
                        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                        credentials: "same-origin",
                        body: JSON.stringify({ updates }),
                        method: "POST"
                    }).then(response2 => response2.json());
                    const cartDrawerSectionId = getCartDrawerSectionId();
                    let newPayload = {
                        id: upgradedVariant.id,
                        quantity: currentVariant.quantity,
                        properties: currentVariant.properties,
                        sections: [cartDrawerSectionId, "header-classic"],
                        sections_url: window.location.pathname
                    };
                    newPayload.properties._lens_upgrades = upgradedVariant.option3.toLowerCase();
                    newPayload.properties._highindex_upgrade = "YES";
                    const response = await fetch("/cart/add.js", {
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(newPayload),
                        method: "POST"
                    }).then(response2 => response2.json());
                    let itemToReplace = document.querySelector(`.rx-form-compatibility-frame[index="${index2}"]`);
                    itemToReplace.style.opacity = "0.7";
                    itemToReplace.setAttribute("data-id", upgradedVariant.id);
                    itemToReplace.querySelector(".rx-form-compatibility-frame-list-variantname").innerHTML = upgradedVariant.title;
                    itemToReplace.querySelector(".rx-form-compatibility-frame-actions span").innerHTML = "Upgraded";
                    itemToReplace.querySelector(".rx-form-compatibility-frame-actions").style.pointerEvents = "none";
                    replaceCartDrawerContentFromSections(response.sections);
                    const bubble = new DOMParser().parseFromString(response.sections["header-classic"], "text/html").querySelector(".header-cart__count").innerHTML;
                    document.querySelectorAll(".header-cart__count").forEach(element => { element.innerHTML = bubble; });
                    addToCartBtns[1].classList.add("confirm-checkout");
                } else {
                    addToCartBtns[1].classList.add("confirm-checkout");
                }
            });
        }
    }
};

const getUniqueListBy = (arr, key) => [...new Map(arr.map(item => [item[key], item])).values()];

const checkSphereCylinderValue = key => {
    const errors = [];
    if (["_right_sphere", "_left_sphere", "_right_cylinder", "_left_cylinder"].includes(key)) {
        const rs = +payload.properties._right_sphere;
        const ls = +payload.properties._left_sphere;
        const rc = +payload.properties._right_cylinder;
        const lc = +payload.properties._left_cylinder;
        if (ls * rs < 0 && ["_left_sphere", "_right_sphere"].includes(key)) errors.push("different powers (-/+) between OD & OS Spheres");
        if (lc * rc < 0 && ["_left_cylinder", "_right_cylinder"].includes(key)) errors.push("different powers (-/+) between OD & OS Cylinders");
        if (ls * lc < 0 && ["_left_sphere", "_left_cylinder"].includes(key)) errors.push("different powers (-/+) between OS Sphere & Cylinder");
        if (rs * rc < 0 && ["_right_sphere", "_right_cylinder"].includes(key)) errors.push("different powers (-/+) between OD Sphere & Cylinder");
        if (Math.abs(ls - rs) > 4 && ["_left_sphere", "_right_sphere"].includes(key)) errors.push("a greater than average variation in values between OD & OS Spheres");
        if (Math.abs(lc - rc) > 4 && ["_left_cylinder", "_right_cylinder"].includes(key)) errors.push("a greater than average variation in values between OD & OS Cylinders");
        if (errors.length) return { validValue: !1, errors };
    }
    return { validValue: !0, errors: [] };
};

const checkPDValue = value => (value >= 30 && value < 57) || (value <= 80 && value > 68)
    ? { validValue: !1, errors: ["your PD is outside the average range of 57 - 68"] }
    : { validValue: !0, errors: [] };

const openConfirmModal = () => {
    var _allValid = !0;
    let pdSum = 0;
    payload.properties._pd == 1
        ? pdSum = +payload.properties._pd_left * 2
        : pdSum = +payload.properties._pd_left + +payload.properties._pd_right;
    const pdValidity = checkPDValue(pdSum);
    for (const key in payload.properties) {
        if (Object.hasOwnProperty.call(payload.properties, key)) {
            const value = payload.properties[key];
            const rxInfoEl = document.querySelector(`#rx${key} .rx-info-criteria-value`);
            const rxInfoInvalidBadge = document.querySelector(`#rx${key} .tooltip`);
            if (rxInfoEl) {
                const { validValue, errors } = checkSphereCylinderValue(key);
                if (!validValue && errors.length) {
                    _allValid = !1;
                    rxInfoInvalidBadge.style.visibility = "visible";
                    const errorText = errors.length === 1
                        ? `We noticed ${errors[0]}`
                        : `We noticed: <ul>${errors.reduce((acc, cur) => `${acc}<li><span>${cur}</span></li>`, "")}</ul>`;
                    rxInfoInvalidBadge.querySelector(".tooltiptext").innerHTML = errorText;
                }
                if (["_pd", "_pd_left", "_pd_right"].includes(key) && !pdValidity.validValue && pdValidity.errors.length) {
                    _allValid = !1;
                    rxInfoInvalidBadge.style.visibility = "visible";
                    const errorText = pdValidity.errors.length === 1
                        ? `We noticed ${pdValidity.errors[0]}`
                        : `We noticed: <ul>${pdValidity.errors.reduce((acc, cur) => `${acc}<li><span>${cur}</span></li>`, "")}</ul>`;
                    rxInfoInvalidBadge.querySelector(".tooltiptext").innerHTML = errorText;
                }
                ["_right_sphere", "_left_sphere", "_right_cylinder", "_left_cylinder"].includes(key)
                    ? rxInfoEl.innerHTML = +value > 0 ? `+${value}` : value
                    : rxInfoEl.innerHTML = value;
                $(`#rx${key}`).show();
            }
            if (key === "_additional_data_text" && value === "") {
                $(`#rx${key}`).hide();
                delete payload.properties[key];
            }
        }
    }
    payload.properties._pd == 1
        ? ($("#rx_pd_left").hide(), $("#rx_pd_right").hide(),
           $("#rx_pd .rx-info-criteria-value").html(payload.properties._pd_left * 2), $("#rx_pd").show())
        : $("#rx_pd").hide();
    _allValid ? $(".rx-info-criteria i").hide() : $(".rx-info-criteria i").show();
    document.querySelector("#rx-product-section-confirm-modal").classList.add("active");
};

const closeConfirmModal = () => {
    confirmCheckbox.checked = !1;
    document.querySelector("#rx-product-section-confirm-modal").classList.remove("active");
};

const confirmSubmit = () => {
    if (!confirmCheckbox.checked) {
        document.getElementById("confirm-error").classList.add("active");
        state.hasError = !0;
    } else {
        const has_progressive = document.querySelector("#rx-product-submit").getAttribute("has-progressive");
        if (rightSphere.value === "" || rightCylinder.value === "" || rightAxis.value === "" ||
            leftSphere.value === "" || leftCylinder.value === "" || leftAxis.value === "" ||
            (has_progressive == "true" && (leftCorrection.value === "" || rightCorrection.value === ""))) {
            state.hasError = !0;
        } else {
            state.hasError = !1;
        }
        closeConfirmModal();
        addVariantToCart();
    }
};

const toggleTooltip = element => {};
